import { ROUTES } from '@constants'

import type { RouteStrategy, RouteStrategyParams } from './routeStrategy'

export class FormRoute implements RouteStrategy {
  public getRedirectPath(params: RouteStrategyParams): string | undefined {
    const { code } = params

    if (!code) {
      console.warn('Code is required to redirect to config')

      return
    }

    return `${ROUTES.CONFIG_FORMS_EDIT}/${code}`
  }
}
